module.exports = __webpack_public_path__ + "static/media/fastklinik_web.0c4055a9.png";